import EntryActionTypes from '../../constants/EntryActionTypes';

export const fetchInvoicesElectricity = (currentMonth) => ({
  type: EntryActionTypes.INVOICES_ELECTRICITY_FETCH_REQUEST,
  payload: {
    currentMonth,
  },
});

export const fetchInvoicesWater = (currentMonth) => ({
  type: EntryActionTypes.INVOICES_WATER_FETCH_REQUEST,
  payload: {
    currentMonth,
  },
});

export const fetchInvoicesGas = (currentMonth) => ({
  type: EntryActionTypes.INVOICES_GAS_FETCH_REQUEST,
  payload: {
    currentMonth,
  },
});
